import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "word-count-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 6h16a1 1 0 011 1v.01a1 1 0 01-1 1H4a1 1 0 01-1-1V7a1 1 0 011-1zm16 5H4a1 1 0 00-1 1 1 1 0 001 1h16a1 1 0 001-1 1 1 0 00-1-1zM4 18h10a1 1 0 001-1 1 1 0 00-1-1H4a1 1 0 00-1 1 1 1 0 001 1z"
    }, null, -1)
  ])))
}
export default { render: render }